import { BaseModel } from "sjs-base-model";

export default class AmministrazioneModel extends BaseModel {
    public readonly idAmministrazione: number = 0;
    public readonly idCategoriaAmministrativa: number = 0;
    public readonly denominazione: string = "";
    public readonly ndg: number = 0;
    public readonly piva: string = "";
    public readonly nomeComune: string = "";
    public readonly cap: string = "";
    public readonly codProvincia: string = "";
    public readonly indirizzo: string = "";
    public readonly telefono: string = "";
    public readonly descrProvincia: string = "";
    /*
     * Client-Side properties (Not from API)
     */
    // public noneApiProperties: unknown = null;
    constructor(data: Partial<AmministrazioneModel>) {
        super();

        this.update(data);
    }
}
